import { Component } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';
register();

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html'
})
export class HomeComponent {
  lang = localStorage.getItem('language') || 'ar';
  activeHeroIndex = 0;
  autoPlayInterval: any;
  heroSlides = [
    {
      title: 'home.slidetitle1',
      text: 'home.slidetext1',
      src: 'assets/images/home/thrwtyvideo.mp4',
      type: 'video'
    },
    {
      title: 'home.slidetitle2',
      text: 'home.slidetext2',
      src: 'assets/images/home/hero2.jpg',
      type: 'image'
    },
    {
      title: 'home.slidetitle3',
      text: 'home.slidetext3',
      src: 'assets/images/home/hero3.jpg',
      type: 'image'
    },
  ];

  clients = [
    'assets/images/home/clients/2222.SR_BIG 1.svg',
    'assets/images/home/clients/Al_Rajhi_Bank_Logo 2.svg',
    'assets/images/home/clients/Alawal_Bank_Logo 2.svg',
    'assets/images/home/clients/Logo_Saudi_Arabian_Monetary_Authority 1.svg',
    'assets/images/home/clients/Logo_Saudi_Electric_Company 1.svg'
  ]
  // @ViewChild('swiperComponent') swiperComponent: SwiperComponent;
  clientsSliderConfig: SwiperOptions = {
    slidesPerView: 'auto',
    navigation: false,
    pagination: false,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    speed: 3000,
    freeMode: true,
    grabCursor: true,
  };

  constructor() {
    this.startHeroSlider();
  }

  startHeroSlider() {
    this.autoPlayInterval = setInterval(() => {
      this.activeHeroIndex = (this.activeHeroIndex + 1) % this.heroSlides.length;
    }, 10000);
  }
  stopHeroSlider() {
    clearInterval(this.autoPlayInterval);
  }
  navHeroSlider(direction: string) {
    if (direction === 'next') {
      this.activeHeroIndex = (this.activeHeroIndex + 1) % this.heroSlides.length;
    } else {
      this.activeHeroIndex = this.activeHeroIndex == 0 ? this.heroSlides.length - 1 : this.activeHeroIndex - 1;
    }
  }
}
